import { billToSelectorStyles } from "@insite/content-library/Components/BillToSelector";
import { fontFamilyAlt } from "@waytek/Utilities/variables";

billToSelectorStyles.noBillTosText = {
    ...billToSelectorStyles.noBillTosText,
    variant: "h4",
    fontFamily: fontFamilyAlt,
    transform: "none",
};
